<template>
  <div>
    <div id="map-container-calibration" :style="{'height': mapHeight + 80 + 'px'}" style="line-height: 1">
      <MglMap
          ref="mapboxMapHome"
          container="map-container-calibration"
          :accessToken="$env.VUE_APP_ACCESS_TOKEN"
          :center="mapCenter"
          :zoom="mapZoom"
          :style="{'height': mapHeight + 80 + 'px'}"
          :mapStyle="mapStyle"
          @click="onMapClicked"
          @load="onMapLoaded">
        <!--        <draw-controls @onDrawModeSelected="onDrawModeSelected" @onDrawModeDelete="onDeleteItem"
                               mode="full"></draw-controls>-->
        <!--        <div class="listing-group-top-left" style="top: 64px;">
                  <b-button v-if="selectedItem">{{ selectedItem.wayLabel }} -> {{ selectedItem.wayKitLabel }}</b-button>
                </div>-->
        <div style="position: absolute;bottom: 8px;right: 8px;z-index: 1; padding: 8px; background-color: rgba(255,255,255,0.75); border-radius: 8px;">
            <b-field>
              <b-checkbox v-model="isHighRes" @input="onChangeMapSource">High Res Map</b-checkbox>
            </b-field>
        </div>

      </MglMap>

    </div>
  </div>
</template>

<script>

import Mapbox from "mapbox-gl";
import {mapGetters, mapState} from "vuex";
import {MglMap} from "vue-mapbox";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import {point, distance} from "@turf/turf";
import {VideoCalibrationCategory} from "@/utils/utils";

export default {
  name: "draw-map",
  props: {
    selectedTab: null,
    selectedApproach: null
  },
  components: {MglMap},
  data() {
    return {
      mapStyle: '',
      mapCenter: [144.94444, -37.80193],
      mapZoom: 18,
      drawMode: null,
      mapRotation: 0,
      allDrawings: null,
      highResolutionStyle: null,
      mapHeight: 200,
      features: null,
      crossingDistanceFeatures: null,
      isHighRes: true,
      // Crossing config state
      crossingClickMode: false,
      crossingMarkers: [],
      crossingCurrentColor: '#00ff00',
      // Store crossing zones for redraw after style load
      pendingCrossingZones: null,
      pendingCrossingWaitingAreas: null
    }
  },
  created() {
    this.map = null
    if (this.selectedDevice && this.selectedDevice.location) {
      this.mapCenter = this.selectedDevice.location.coordinates
    }

    const rasterTilesSource = {
      type: 'raster',
      tiles: [
        'https://map.webtunel.com/download?z={z}&y={y}&x={x}'
      ],
      tileSize: 256,
      attribution: 'Map tiles by RTT'
    };
    const rasterTilesLayer = {
      id: 'simple-tiles',
      type: 'raster',
      source: 'raster-tiles',
      minzoom: 18,
      maxzoom: 22
    };
    this.highResolutionStyle = {
      version: 8,
      sources: {
        'raster-tiles': rasterTilesSource
      },
      layers: [rasterTilesLayer]
    }

    //this.mapStyle = this.highResolutionStyle
    this.isHighRes = false
    this.mapStyle = 'mapbox://styles/mapbox/satellite-streets-v11?optimize=true'
  },
  mounted() {
    this.isHighRes = false
    this.mapStyle = 'mapbox://styles/mapbox/satellite-streets-v11?optimize=true'
    if (this.selectedDevice && this.selectedDevice.location) {
      this.mapCenter = this.selectedDevice.location.coordinates
    }
    this.draw = null;
  },
  methods: {
    onChangeMapSource(value){
      console.log('On change map source: ', value)
      if(value){
        this.mapStyle = this.highResolutionStyle
      }else{
        this.mapStyle = 'mapbox://styles/mapbox/satellite-streets-v11?optimize=true'
      }
    },
    setMapHeight(mapHeight) {
      this.mapHeight = mapHeight
      if (this.map) {
        this.map.resize()
        setTimeout(() => {
          this.map.resize()
        }, 1000)
      }
    },
    onDrawModeSelected(mode) {
      this.drawMode = mode
      // Note: MapboxDraw handles its own cursor, this is for custom draw controls
      // which are currently commented out. Leaving cursor handling to MapboxDraw.
      console.log('Draw mode', this.drawMode)
    },
    onMapClicked(event) {
      console.log('On map clicked', event)
      if (this.crossingClickMode) {
        // Emit crossing map click for geo point collection
        this.$emit('onCrossingMapClick', event.mapboxEvent.lngLat.lng, event.mapboxEvent.lngLat.lat)
      } else if (this.drawMode && this.drawMode.includes('add')) {
        this.$emit('onMapInputClicked', {drawMode: this.drawMode, coordinates: event.mapboxEvent.lngLat})
      } else {
        this.$emit('onMapClicked', event.mapboxEvent.lngLat)
      }
    },
    onMapLoaded(map) {
      console.log('On map loaded')
      let obj = this
      this.map = map.map;
      this.mapStyle = this.highResolutionStyle
      this.isHighRes = true
      this.addDraw()
      setTimeout(() => {
        this.map.resize()
      }, 300)

      // Listen for style load to redraw crossing zones
      this.map.on('style.load', () => {
        console.log('Map style loaded, redrawing crossing zones')
        if (this.pendingCrossingZones || this.pendingCrossingWaitingAreas) {
          this.drawCrossingZonesInternal()
        }
      })
    },
    addDraw(activeTab = null) {
      // Use activeTab if provided, otherwise use selectedTab prop
      const tab = activeTab !== null ? activeTab : this.selectedTab
      console.log('addDraw called - activeTab:', tab, 'selectedTab prop:', this.selectedTab, 'draw exists:', !!this.draw, 'map exists:', !!this.map)

      // Always try to remove existing draw control first
      if (this.draw) {
        try {
          this.map.removeControl(this.draw)
          console.log('addDraw - removed existing draw control')
        } catch (e) {
          console.log('addDraw - error removing draw control:', e)
        }
        this.draw = null
      }

      if (!this.map) {
        console.log('addDraw - map not available, skipping')
        return
      }

      if (tab === 0 || tab === 5) {
        console.log('addDraw - creating new MapboxDraw for tab', tab)
        this.draw = new MapboxDraw({
          controls: {
            line_string: true,
            trash: true
          },
          displayControlsDefault: false,
          styles: [
            {
              'id': 'gl-draw-line-inactive',
              'type': 'line',
              'filter': ['all', ['==', 'active', 'false'],
                ['==', '$type', 'LineString'],
                ['!=', 'mode', 'static']
              ],
              'layout': {
                'line-cap': 'round',
                'line-join': 'round'
              },
              'paint': {
                'line-color': '#ffffff',
                'line-width': 4
              }
            },
            {
              'id': 'gl-draw-line-active',
              'type': 'line',
              'filter': ['all', ['==', '$type', 'LineString'],
                ['==', 'active', 'true']
              ],
              'layout': {
                'line-cap': 'round',
                'line-join': 'round'
              },
              'paint': {
                'line-color': '#fc2d07',
                'line-dasharray': [0.2, 2],
                'line-width': 4
              }
            },]
        });
        this.map.addControl(this.draw, 'top-right');
        console.log('addDraw - MapboxDraw control added successfully')

        // Reset cursor to let MapboxDraw handle it
        this.map._canvas.style.cursor = ''

        // Remove old event listeners before adding new ones
        this.map.off('draw.create', this.updateDrawn);
        this.map.off('draw.delete', this.onDeleteDrawn);
        this.map.off('draw.update', this.updateDrawn);

        this.map.on('draw.create', this.updateDrawn);
        this.map.on('draw.delete', this.onDeleteDrawn);
        this.map.on('draw.update', this.updateDrawn);
        console.log('addDraw - event listeners registered');

        // Store tab in closure to use correct value in setTimeout
        const currentTab = tab
        setTimeout(() => {
          console.log('addDraw setTimeout - restoring features for tab:', currentTab)
          console.log('addDraw setTimeout - this.features:', this.features ? JSON.stringify(this.features) : 'null')
          if (!this.draw) {
            console.log('addDraw setTimeout - draw control no longer exists, skipping')
            return
          }
          this.draw.deleteAll()
          if (currentTab === 5) {
            if (this.features) {
              console.log('addDraw - adding features to draw:', JSON.stringify(this.features))
              this.draw.add(this.features)
            } else {
              console.log('addDraw - no features to add for tab 5')
            }
          } else if (currentTab === 0) {
            if (this.crossingDistanceFeatures) {
              console.log('addDraw - adding crossingDistanceFeatures to draw')
              this.draw.add(this.crossingDistanceFeatures)
            }
          }
          this.map.resize()
          console.log('addDraw - draw control ready, features in draw:', this.draw.getAll())
        }, 500)
      }

    },
    removeDraw() {
      if (this.map && this.draw) {
        this.map.removeControl(this.draw)
        this.draw = null
      }
    },
    clearDrawings() {
      this.draw.deleteAll()
    },
    updateDrawn(event) {
      console.log('On draw changed: ', event)
      console.log('All drawings', this.draw.getAll())

      if (this.selectedTab === 5) {
        this.features = JSON.parse(JSON.stringify(this.draw.getAll()))
        this.draw.deleteAll()

        console.log('On draw, selected approach is: ', this.selectedApproach)
        if (this.features && this.features.features && this.features.features.length > 0) {
          this.features.features.forEach((feature, index) => {
            feature['id'] = `${VideoCalibrationCategory.SPEED_LINE}_${index}_${this.selectedApproach.key}`
            feature['approach'] = this.selectedApproach.key
          })
        }

        this.draw.add(this.features)
      } else if (this.selectedTab === 0) {
        this.crossingDistanceFeatures = JSON.parse(JSON.stringify(this.draw.getAll()))
        this.draw.deleteAll()

        if (this.crossingDistanceFeatures && this.crossingDistanceFeatures.features && this.crossingDistanceFeatures.features.length > 0) {
          this.crossingDistanceFeatures.features.forEach((feature, index) => {
            feature['id'] = `${VideoCalibrationCategory.STAGE_POLYGON}_${index}`
          })
        }
        this.draw.add(this.crossingDistanceFeatures)
      }

      this.$emit('onLinesDrawn', this.draw.getAll())

      console.log('All drawings with id', this.draw.getAll())

    },
    onDeleteDrawn(event) {
      console.log('On draw changed: ', event)
      console.log('All drawings', this.draw.getAll())
      if (this.selectedTab === 5) {
        this.features = JSON.parse(JSON.stringify(this.draw.getAll()))
      } else if (this.selectedTab === 0) {
        this.crossingDistanceFeatures = JSON.parse(JSON.stringify(this.draw.getAll()))
      }

      this.$emit('onLinesDrawn', this.draw.getAll())
    },
    deleteFeature(index) {
      console.log('On delete line with index: ', index)
      if (this.selectedTab === 5) {
        if (this.features && this.features.features && this.features.features.length > 0) {
          if (index < this.features.features.length) {
            this.features.features.splice(index, 1)
            this.draw.deleteAll()
            this.draw.add(this.features)
            this.$emit('onLinesDrawn', this.draw.getAll())
          }
        }
      } else if (this.selectedTab === 0) {
        if (this.crossingDistanceFeatures && this.crossingDistanceFeatures.features && this.crossingDistanceFeatures.features.length > 0) {
          if (index < this.crossingDistanceFeatures.features.length) {
            this.crossingDistanceFeatures.features.splice(index, 1)
            this.draw.deleteAll()
            this.draw.add(this.crossingDistanceFeatures)
            this.$emit('onLinesDrawn', this.draw.getAll())
          }
        }
      }


      console.log('After delete features: ', this.features)
      console.log('After delete crossing: ', this.crossingDistanceFeatures)
      if(this.draw){
        console.log('After delete draw: ', this.draw.getAll())
      }
    },
    setFeature(features) {
      this.features = features
    },
    setCrossingDistanceFeature(features) {
      this.crossingDistanceFeatures = features
    },
    changeStyle(style) {
      this.mapStyle = style
    },
    mapboxGl() {
      return Mapbox
    },
    markerClicked(item) {
      console.log('Marker clicked map input:', item)
    },
    zoomMapToSelectedSiteOrProject() {
      const startPoint = {
        center: this.mapCenter,
        zoom: 13,
        pitch: 0,
        bearing: 0
      };
      this.map.flyTo(startPoint)
    },
    onClose() {
      this.features = null
      this.crossingDistanceFeatures = null
      this.removeDraw()
    },
    addOrRemoveDraw(forceTab = null) {
      // Use forceTab if provided, otherwise use selectedTab prop
      const activeTab = forceTab !== null ? forceTab : this.selectedTab
      console.log('addOrRemoveDraw - activeTab:', activeTab, 'selectedTab prop:', this.selectedTab, 'forceTab:', forceTab)
      console.log('addOrRemoveDraw - map exists:', !!this.map, 'draw exists:', !!this.draw)
      console.log('addOrRemoveDraw - crossingClickMode:', this.crossingClickMode)
      if(this.map){
        if (activeTab === 5 || activeTab === 0) {
          this.addDraw(activeTab)
        } else {
          this.removeDraw()
        }
      }
    },
    // Crossing Config Methods
    enableCrossingClickMode(enabled) {
      this.crossingClickMode = enabled
      // Only change cursor if we're on Crossing Config tab (tab 4)
      // Don't interfere with MapboxDraw cursor on other tabs
      if (this.map && this.selectedTab === 4) {
        this.map._canvas.style.cursor = enabled ? 'crosshair' : 'grab'
      }
    },
    drawCrossingPoints(points, color) {
      // Clear existing markers
      this.clearCrossingPoints()

      if (!points || points.length === 0 || !this.map) return

      this.crossingCurrentColor = color || '#00ff00'

      // Add markers for each point
      points.forEach((coord, index) => {
        // Create marker element
        const el = document.createElement('div')
        el.className = 'crossing-map-marker'
        el.style.width = '20px'
        el.style.height = '20px'
        el.style.background = this.crossingCurrentColor
        el.style.borderRadius = '50%'
        el.style.display = 'flex'
        el.style.alignItems = 'center'
        el.style.justifyContent = 'center'
        el.style.fontSize = '11px'
        el.style.fontWeight = 'bold'
        el.style.color = '#000'
        el.style.boxShadow = '0 2px 4px rgba(0,0,0,0.4)'
        el.style.border = '2px solid #fff'
        el.textContent = (index + 1).toString()

        const marker = new Mapbox.Marker(el)
          .setLngLat([coord[0], coord[1]])
          .addTo(this.map)

        this.crossingMarkers.push(marker)
      })

      // Draw lines between points
      this.drawCrossingLines(points, color)
    },
    drawCrossingLines(points, color) {
      if (!this.map || !points || points.length < 2) return

      // Remove existing crossing line layers
      if (this.map.getLayer('crossing-line')) {
        this.map.removeLayer('crossing-line')
      }
      if (this.map.getSource('crossing-line')) {
        this.map.removeSource('crossing-line')
      }
      if (this.map.getLayer('crossing-closing-line')) {
        this.map.removeLayer('crossing-closing-line')
      }
      if (this.map.getSource('crossing-closing-line')) {
        this.map.removeSource('crossing-closing-line')
      }

      // Add line connecting points
      this.map.addSource('crossing-line', {
        type: 'geojson',
        data: {
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates: points
          }
        }
      })

      this.map.addLayer({
        id: 'crossing-line',
        type: 'line',
        source: 'crossing-line',
        paint: {
          'line-color': color || '#00ff00',
          'line-width': 3,
          'line-dasharray': [2, 2]
        }
      })

      // Add closing line if 3+ points (faded)
      if (points.length >= 3) {
        this.map.addSource('crossing-closing-line', {
          type: 'geojson',
          data: {
            type: 'Feature',
            geometry: {
              type: 'LineString',
              coordinates: [points[points.length - 1], points[0]]
            }
          }
        })

        this.map.addLayer({
          id: 'crossing-closing-line',
          type: 'line',
          source: 'crossing-closing-line',
          paint: {
            'line-color': color || '#00ff00',
            'line-width': 2,
            'line-dasharray': [2, 2],
            'line-opacity': 0.4
          }
        })
      }
    },
    clearCrossingPoints() {
      // Remove markers
      this.crossingMarkers.forEach(marker => marker.remove())
      this.crossingMarkers = []

      // Remove line layers
      if (this.map) {
        if (this.map.getLayer('crossing-line')) {
          this.map.removeLayer('crossing-line')
        }
        if (this.map.getSource('crossing-line')) {
          this.map.removeSource('crossing-line')
        }
        if (this.map.getLayer('crossing-closing-line')) {
          this.map.removeLayer('crossing-closing-line')
        }
        if (this.map.getSource('crossing-closing-line')) {
          this.map.removeSource('crossing-closing-line')
        }
      }
    },
    drawAllCrossingZones(zones, waitingAreas) {
      // Store zones for redraw after style load
      this.pendingCrossingZones = zones
      this.pendingCrossingWaitingAreas = waitingAreas

      if (!this.map) return

      // Check if map style is loaded
      if (!this.map.isStyleLoaded()) {
        console.log('Map style not loaded yet, waiting...')
        return // Will be drawn when style.load fires
      }

      this.drawCrossingZonesInternal()
    },
    drawCrossingZonesInternal() {
      if (!this.map || !this.map.isStyleLoaded()) return

      const zones = this.pendingCrossingZones
      const waitingAreas = this.pendingCrossingWaitingAreas

      // Clear existing zone layers
      this.clearCrossingZoneLayers()

      const ZONE_COLORS = ['#00ff00', '#0080ff', '#00ffff', '#80ff00', '#00ff80', '#0040ff']
      const WAITING_COLORS = ['#ff8000', '#ff0080', '#ffff00', '#ff00ff', '#ff4000', '#ff0040']

      // Draw zones
      if (zones && zones.length > 0) {
        zones.forEach((zone, index) => {
          if (zone.geoPolygon && zone.geoPolygon.length >= 3) {
            const color = ZONE_COLORS[index % ZONE_COLORS.length]
            const sourceId = `crossing-zone-${index}`
            const layerId = `crossing-zone-layer-${index}`
            const outlineLayerId = `crossing-zone-outline-${index}`

            // Close the polygon
            const coords = [...zone.geoPolygon, zone.geoPolygon[0]]

            try {
              this.map.addSource(sourceId, {
                type: 'geojson',
                data: {
                  type: 'Feature',
                  geometry: {
                    type: 'Polygon',
                    coordinates: [coords]
                  }
                }
              })

              // Fill layer
              this.map.addLayer({
                id: layerId,
                type: 'fill',
                source: sourceId,
                paint: {
                  'fill-color': color,
                  'fill-opacity': 0.3
                }
              })

              // Outline layer
              this.map.addLayer({
                id: outlineLayerId,
                type: 'line',
                source: sourceId,
                paint: {
                  'line-color': color,
                  'line-width': 2
                }
              })
            } catch (e) {
              console.warn('Error adding crossing zone layer:', e)
            }
          }
        })
      }

      // Draw waiting areas
      if (waitingAreas && waitingAreas.length > 0) {
        waitingAreas.forEach((area, index) => {
          if (area.geoPolygon && area.geoPolygon.length >= 3) {
            const color = WAITING_COLORS[index % WAITING_COLORS.length]
            const sourceId = `crossing-waiting-${index}`
            const layerId = `crossing-waiting-layer-${index}`
            const outlineLayerId = `crossing-waiting-outline-${index}`

            // Close the polygon
            const coords = [...area.geoPolygon, area.geoPolygon[0]]

            try {
              this.map.addSource(sourceId, {
                type: 'geojson',
                data: {
                  type: 'Feature',
                  geometry: {
                    type: 'Polygon',
                    coordinates: [coords]
                  }
                }
              })

              // Fill layer
              this.map.addLayer({
                id: layerId,
                type: 'fill',
                source: sourceId,
                paint: {
                  'fill-color': color,
                  'fill-opacity': 0.2
                }
              })

              // Outline layer (dashed)
              this.map.addLayer({
                id: outlineLayerId,
                type: 'line',
                source: sourceId,
                paint: {
                  'line-color': color,
                  'line-width': 3,
                  'line-dasharray': [2, 2]
                }
              })
            } catch (e) {
              console.warn('Error adding waiting area layer:', e)
            }
          }
        })
      }
    },
    clearCrossingZoneLayers() {
      // Clear pending data
      this.pendingCrossingZones = null
      this.pendingCrossingWaitingAreas = null

      if (!this.map) return

      // Remove zone layers (up to 20 of each type)
      for (let i = 0; i < 20; i++) {
        const zoneLayerId = `crossing-zone-layer-${i}`
        const zoneOutlineId = `crossing-zone-outline-${i}`
        const zoneSourceId = `crossing-zone-${i}`
        const waitingLayerId = `crossing-waiting-layer-${i}`
        const waitingOutlineId = `crossing-waiting-outline-${i}`
        const waitingSourceId = `crossing-waiting-${i}`

        if (this.map.getLayer(zoneLayerId)) this.map.removeLayer(zoneLayerId)
        if (this.map.getLayer(zoneOutlineId)) this.map.removeLayer(zoneOutlineId)
        if (this.map.getSource(zoneSourceId)) this.map.removeSource(zoneSourceId)
        if (this.map.getLayer(waitingLayerId)) this.map.removeLayer(waitingLayerId)
        if (this.map.getLayer(waitingOutlineId)) this.map.removeLayer(waitingOutlineId)
        if (this.map.getSource(waitingSourceId)) this.map.removeSource(waitingSourceId)
      }
    }
  },
  computed: {
    ...mapState({}),
    ...mapGetters({
      getMapStyle: 'getMapStyle',
      selectedDevice: 'dataProcessingTmcModule/getTmcSelectedProcessingDevice'
    }),
  },
  // Watch removed - parent now explicitly calls addOrRemoveDraw with correct tab index
  // This prevents duplicate MapboxDraw initialization
  watch: {
  }

}
</script>

<style scoped>
</style>